/* eslint-disable jsx-a11y/anchor-is-valid */
import Link from 'next/link'
import styles from '../../ListPage.module.scss'
import { useEffect } from 'react'
import { gsap, Power4 } from 'gsap'

import React from 'react'

interface CaseStudyItem {
  projectName: string | React.ReactNode
  client: string
  src: string
  alt: string
  id: string
  tags: Array<{ tag: string; href: string }>
  linkToDetail?: string
}

interface CaseStudyListProps {
  items: CaseStudyItem[]
}

const CaseStudyList: React.FC<CaseStudyListProps> = ({ items }) => {
  useEffect(() => {
    const elements = document.querySelectorAll(`.${styles.caseitem}`)
    gsap.set(elements, { opacity: 0, y: 50 })
    gsap.to(elements, {
      opacity: 1,
      y: 0,
      duration: 1,
      stagger: 0.2,
      ease: Power4.easeOut,
    })
  }, [items])

  return (
    <ul className={styles.caselist}>
      {items.map(({ projectName, client, id, tags, src, alt, linkToDetail }) => (
        <li key={id} className={styles.caseitem}>
          {linkToDetail ? (
            <Link href={linkToDetail}>
              <a className={styles.caseitem_pic}>
                <figure className={styles.caseitem_pic_img}>
                  <img src={src} alt={alt} className={styles.caseitem_pic_img_item} />
                </figure>
              </a>
            </Link>
          ) : (
            <div className={styles.caseitem_pic}>
              <figure className={styles.caseitem_pic_img}>
                <img src={src} alt={alt} className={styles.caseitem_pic_img_item} />
              </figure>
            </div>
          )}
          <div className={styles.caseitem_info}>
            {linkToDetail ? (
              <Link href={linkToDetail}>
                <a className={styles.caseitem_main}>
                  <div className={styles.caseitem_main_project}>{projectName}</div>
                  <div className={styles.caseitem_main_client}>{client}</div>
                </a>
              </Link>
            ) : (
              <div className={styles.caseitem_main}>
                <div className={styles.caseitem_main_project}>{projectName}</div>
                <div className={styles.caseitem_main_client}>{client}</div>
              </div>
            )}
            <ul className={styles.caseitem_tag}>
              {tags.map((tagItem, index) => (
                <li
                  key={`${tagItem.tag}-${index}`}
                  className={`${
                    [
                      'IT/情報/通信',
                      'メーカー/製造/建設',
                      '金融/不動産',
                      '小売/流通/卸',
                      'サービス',
                      '公共/行政',
                      'その他',
                    ].includes(tagItem.tag)
                      ? styles.caseitem_tag_white
                      : styles.caseitem_tag_gray
                  }`}
                >
                  <a href={tagItem.href} className={styles.categoryButton} onClick={(e) => e.stopPropagation()}>
                    {tagItem.tag}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </li>
      ))}
    </ul>
  )
}

export default CaseStudyList
